<div class="spinner" *ngIf="!dataLoaded"></div>
<ng-container *ngIf="dataLoaded">
    <h2>Fleet Details</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-7 col-md-5 mvd_form-group">
                <label>Motor Carrier Name</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.motorCarrierAccountName}}">
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Motor Carrier Account #</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.motorCarrierAccountNumber}}">
            </div>
            <div class="col-sm-3 col-md-2 col-lg-2 mvd_form-group">
                <label>IRP Account #</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.irpAccountNumber}}">
            </div>
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>IFTA Account #</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.iftaAccountNumber}}">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>Fleet #</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.fleetNumber}}">
            </div>
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>Expiration Date</label>
                <input class="mvd_form-control" disabled="" type="text" value="{{motorCarrierAccount.expirationDate | shortDate}}">
            </div>
        </div>
    </fieldset>
    <fieldset *ngIf="showIRPVehicleSearch">
        <div class="row">
            <div class="col-sm-7 col-md-5 mvd_form-group">
                <vehicle-search-bar  [label]="'Vehicle'"
                                    (onItemSelected)="vehicleSelected($event)" (onItemRemoved)="vehicleRemoved()">
                </vehicle-search-bar>
            </div>
        </div>
    </fieldset>
</ng-container>